(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    (() => {
    const openSizeGuide = () => {
      const target = document.getElementById('animia-ring-size-guide');

      if (!target) {
        return;
      }

      target.open = true;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const link = event.target.closest('a[href="#animia-ring-size-guide"]');

      if (!link) {
        return;
      }

      event.preventDefault();
      openSizeGuide();
      window.history.pushState(null, '', '#animia-ring-size-guide');
    });

    if (window.location.hash === '#animia-ring-size-guide') {
      window.requestAnimationFrame(openSizeGuide);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
